<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn :to="{ name: 'Reports' }" color="primary" outlined right fab small class="mr-4"><v-icon>mdi-close</v-icon></v-btn>
      <div class="title primary--text">{{ section }} {{ area_name.name }}</div>
    </div>

    <v-flex xs12>
      <v-card class="mx-auto mt-5" tile>
        <template>
          <v-container fluid class="mb-0 pb-0">
            <v-row>

              <!-- Filtro por forma de pago y platillo -->
              <v-col cols="12" md="3" />

              <!-- Filtro por periodo -->
              <v-col cols="12" md="6" class="text-right pb-0 pt-5">
                <date-tab-filter :dates="dates" :period="period" v-on:update:filter="filter = $event" v-on:update:period="period = $event" v-on:update:dates="dates = $event"></date-tab-filter>
              </v-col>

              <!-- Filtro por rango de fecha -->
              <v-col cols="12" md="3" class="pb-0 pt-1 text-right">
                <date-filter :filter="filter" :dates="dates" v-on:update:change="dates = $event"></date-filter>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template>
          <v-card flat>
            <by-category :period="period" :dates="dates" :reports="reports"/>
          </v-card>
        </template>
      </v-card>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import ByCategory from './components/ByCategory'
import DateTabFilter from '../../components/DateTabFilter'
import DateFilter from '../../components/DateFilter'
export default {
  name: 'purchases-bar',
  components: {
    'by-category': ByCategory,
    DateTabFilter,
    DateFilter
  },
  data () {
    return {
      section: this.$i18n.t('reports.purchases'),
      overlay: false,
      filter: 0,
      period: 'week',
      modal: false,
      dates: [],
      tab: null,
      items: [
        { tab: 'Por departamento', component: 'by-category' },
        { tab: 'Por fecha', component: 'by-date' }
      ],
      reports: []
    }
  },
  computed: {
    // Return any computed data
    dateRangeText () {
      return this.dates.join(' al ')
    },
    ...mapGetters(['restaurant', 'areas']),
    area_name () {
      return this.areas.find(area => area.id === this.$route.params.id)
    },
    queryParams () {
      const { dates, period } = this.$route.query
      return { dates, period }
    }
  },
  mounted () {
    this.dates = this.queryParams.dates
    this.period = this.queryParams.period
  }
}
</script>
